module.exports = __webpack_public_path__ + "static/media/kidsartkids_01_A.5f57b409.png";